module.exports = require("./dist/gatsby/gatsby-browser");